module.exports = __webpack_public_path__ + "img/mission.354a0bf.webp";